import { Navigate, Outlet } from "react-router-dom";
import { isLoggedInMember } from "../../../auth";
const FamilyMemberLoginCheck = ()=>{
    return isLoggedInMember()?<Outlet/>:<Navigate to='/family/login'/>
}
export default FamilyMemberLoginCheck;